import styled, { css } from "styled-components/macro";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  position: relative;
  background-color: #f5f5f5;
`;

export const PageTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #dddddd;
  background-color: #fff;
  padding: 15px 0;
  font-size: 1.13em;
  position: relative;
  .pagetit {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 2.5vw;
    font-family: "spoqa500";
  }
  .move-btn {
    position: absolute;
    height: 100%;
    top: 0;
    right: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    & img {
      cursor: pointer;
      width: 100%;
    }
  }

  @media screen and (min-width: 1050px) {
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #dddddd;
    background-color: #fff;
    padding: 20px 0;
    font-size: 1.4em;
    position: relative;

    .move-btn {
      position: absolute;
      width: 1.5%;
      height: 100%;
      top: 0;
      right: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      & img {
        cursor: pointer;
        width: 100%;
      }
    }
  }
`;

export const Calendar = styled.div`
  width: 100%;

  .rmdp-shadow {
    width: 100%;
  }
  .rmdp-top-class {
    display: block !important;
  }
  .rmdp-day-picker {
    display: block !important;
  }
  .rmdp-week {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
  .rmdp-day span {
    width: 30px;
    height: 30px;
    margin: 0 auto;
  }
  .rmdp-panel-header {
    display: none;
  }
  .rmdp-panel-body {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .rmdp-panel-body li {
    width: 180px;
    margin-left: 5px;
  }
`;

export const InsectSelect = styled.div`
  width: 100%;
  padding: 20px 40px;
  background-color: #fff;
  border-top: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;
  margin-top: 8px;

  .content-tit {
    font-family: "spoqa500";
    font-size: 1em;
  }
  @media screen and (min-width: 1050px) {
    .content-tit {
      font-size: 1.2em;
    }
  }
`;

export const CheckBox = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 15px;

  input[type="checkbox"] {
    appearance: none;
    width: 13px;
    height: 13px;
    border: 1.125px solid #dddddd;
    margin-right: 5px;
    position: relative;
    top: 1px;

    &:checked {
      border-color: transparent;
      background-image: url("./img/checked.svg");
      background-size: 100% 100%;
      background-position: 50%;
      background-repeat: no-repeat;
      background-color: #73972c;
    }
  }
  label {
    font-size: 0.88em;
    font-family: "spoqa500";
  }
  @media screen and (min-width: 1050px) {
    input[type="checkbox"] {
      appearance: none;
      width: 15px;
      height: 15px;
      border: 1.125px solid #dddddd;
      margin-right: 5px;

      &:checked {
        border-color: transparent;
        background-image: url("./img/checked.svg");
        background-size: 100% 100%;
        background-position: 50%;
        background-repeat: no-repeat;
        background-color: #73972c;
      }
    }
    label {
      font-size: 1em;
      font-family: "spoqa500";
    }
  }
`;
export const Diary = styled.div`
  width: 100%;
  background: #fff;
  margin-top: 8px;
  padding-bottom: 20px;

  .content-tit {
    padding: 20px 40px;
    font-size: 0.88em;
  }
  @media screen and (min-width: 1050px) {
    font-size: 1.1em;
  }
`;

export const DiaryList = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 0px 32px;
`;
export const DiaryItem = styled.div`
  width: calc(12% - 8px);
  /* height: 16vw; */
  border: 1px solid red;
  margin-left: 8px;
  margin-top: 5px;
  padding: 1vw 0px;
  border: 1px solid #dddddd;
  background: #f5f5f5;
  border-radius: 3px;
	cursor: pointer;

  &.Completion {
    background: #c3c3c3;
    position: relative;

    & .opacity0 {
      opacity: 0;
    }
    & .Completion-text {
      color: #fff;
      font-size: 1.5vw;
      position: absolute;
      left: 6px;
      bottom: 20%;
    }
  }
`;

export const ItemInsectName = styled.div`
  width: 100%;
  padding: 0 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .insect-img {
    width: 20%;

    & img {
      width: 100%;
    }
  }
  .insect-name {
    font-size: 1vw;
  }
`;

export const ItemBoxName = styled.div`
  width: 100%;
  padding: 0px 6px;
  .item-box-main {
    width: 100%;
    font-size: 1.5vw;
  }
  .item-box-sub {
    font-size: 1.5vw;
  }
`;

export const ItemStateName = styled.div`
  width: 100%;
  padding: 0 6px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  margin-top: 1vw;

  p {
    padding: 5px 10px;
    border-radius: 5px;
    font-size: 1.3vw;

    &.worm {
      background: #73972c;
      border: 1px solid #73972c;
      color: #73972c;
    }

    &.lingbeetle {
      background: #ffecdf;
      border: 1px solid #ffaa6c;
      color: #ffaa6c;
    }

    &.cricket {
      background: #d9e3ff;
      border: 1px solid #537ff9;
      color: #537ff9;
    }
  }
  p:last-child {
    margin-top: 0.8vw;
  }
`;

export const ButtonCon = styled.div`
  /* width: 40px; */
  margin-top: 10px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  div {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 30px;
    width: 100px;
    height: 100%;
    background-color: #3281f5;
    color: #fff;
  }
`;
